import React from 'react';
import styles from './Image.module.scss';
import { addCustomPathToLink, generateKey, sanitizeType } from 'functions';

const DoubleImage = ({ api, type, animationData }) => {
  return (
    !!api.attributes?.images &&
    api.attributes.images.map((image) => (
      <figure className={`${styles.imageBox} ${sanitizeType(type, styles)}`} key={generateKey()} {...animationData}>
        <img className={styles.image} src={addCustomPathToLink(image.src, true)} alt={image.alt} />
      </figure>
    ))
  );
};
export default DoubleImage;
